import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Layout from '../components/SSOLogin';
import Encryption from '../encryption/encryption';
import userApi from '../api/UserApi';

class SSOLoginContainer extends Component {
  constructor() {
    super();
    this.state = {
      error: null,
      success: null,
      loading: false,
      token: null,
      ecardDownload: false,
    };
  }

  async componentDidMount() {
    const { match, me, history } = this.props;
    const { token, relayState } = match.params;

    try {
      this.setState({ loading: true });
      if (this.setToken(token)) {
        this.setState((value) => ({ ...value, loading: true }));
        if (await me()) {
          if (relayState) {
            const policies = await userApi.getPolicies();

            if (policies?.success) {
              const { viewDetails } = this.props;
              const { success, data, message } = await viewDetails(policies?.data[0]);
              console.log('medical card state data: ', data);

              if (success) {
                switch (relayState) {
                  case 'medicalcards': {
                    this.SSORedirect('/home', data, policies?.data, relayState);
                    break;
                  }
                  case 'policy': {
                    this.SSORedirect('/home/policyDetails', data);
                    break;
                  }
                  case 'claims': {
                    this.SSORedirect('/claims', data);
                    break;
                  }
                  case 'claimssubmission': {
                    this.SSORedirect('/addClaim', data);
                    break;
                  }
                  case 'providers': {
                    this.SSORedirect('/home/searchProvider', data);
                    break;
                  }
                  case 'transactionhistory': {
                    this.SSORedirect('/home/transactionHistory', data);
                    break;
                  }
                  case 'services': {
                    this.SSORedirect('/home/services', data);
                    break;
                  }
                  default:
                    history.push('/home');
                }
              } else {
                this.setState((value) => ({ ...value, message }));
              }
            } else {
              this.setState((value) => ({ ...value, message: policies?.message }));
            }
          } else {
            history.push('/home');
          }
        }
        this.setState((value) => ({ ...value, message: 'Invalid token' }));
      }
      this.setState((value) => ({ ...value, loading: false }));
    } catch (e) {
      this.setState((value) => ({ ...value, loading: false }));
    }
  }

  setToken = (token) => {
    if (token) {
      const decryptedData = this.decryptData(token);
      if (decryptedData) {
        localStorage.setItem('token', decryptedData);
        return true;
      }
    }
    return false;
  };

  decryptData = (encodedData) => Encryption.AESdecryptData(encodedData);

  SSORedirect = (pathname, policyData, policies = null, relayState = null) => {
    const { history } = this.props;

    history.push({
      pathname,
      state: { policyData, relayState, policies },
    });
  };

  /**
   * Render
   */

  render = () => {
    const { me } = this.props;
    const { error, loading, success, message, token, email } = this.state;

    return (
      <Layout error={error} loading={loading} success={success} message={message} token={token} email={email} me={me} />
    );
  };
}

SSOLoginContainer.propTypes = {
  userInput: PropTypes.shape({}).isRequired,
  me: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      token: PropTypes.string.isRequired,
      relayState: PropTypes.string,
    }).isRequired,
  }).isRequired,
  viewDetails: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  userInput: state.articles.userInput || {},
});

const mapDispatchToProps = (dispatch) => ({
  me: dispatch.member.me,
  viewDetails: dispatch.policy.getPolicyDetails,
});

export default connect(mapStateToProps, mapDispatchToProps)(SSOLoginContainer);
